import React from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './AppRoutes'
import './styles.css'

const root = document.getElementById('root')!
const app = <React.StrictMode><BrowserRouter><AppRoutes /></BrowserRouter></React.StrictMode>
if (root.hasChildNodes()) hydrateRoot(root, app)
else createRoot(root).render(app)
